module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/og-aoj_c-87b9f48c19245b10f574e103ee0057f5.png";